export { default as Img200 } from './processed/200/KnightFight.jpg';
export { default as Img400 } from './processed/400/KnightFight.jpg';
export { default as Imgthumb } from './processed/thumb/KnightFight.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/KnightFight.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/KnightFight.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      76,
      140,
      168
    ],
    "_population": 2,
    "_hsl": [
      0.5507246376811593,
      0.3770491803278689,
      0.4784313725490196
    ]
  },
  "LightVibrant": {
    "_rgb": [
      163,
      192,
      239
    ],
    "_population": 221,
    "_hsl": [
      0.6030701754385964,
      0.7037037037037037,
      0.788235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      20,
      36,
      76
    ],
    "_population": 2,
    "_hsl": [
      0.6190476190476191,
      0.5833333333333334,
      0.18823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      104,
      118,
      155
    ],
    "_population": 978,
    "_hsl": [
      0.6209150326797385,
      0.2031872509960159,
      0.5078431372549019
    ]
  },
  "LightMuted": {
    "_rgb": [
      189,
      194,
      211
    ],
    "_population": 160,
    "_hsl": [
      0.6287878787878789,
      0.1999999999999998,
      0.7843137254901961
    ]
  },
  "DarkMuted": {
    "_rgb": [
      53,
      59,
      85
    ],
    "_population": 1371,
    "_hsl": [
      0.6354166666666666,
      0.23188405797101444,
      0.27058823529411763
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/KnightFight.js